<template>
  <a-spin :spinning="loading">
    <a-row>
      <a-descriptions :column="3" style="margin-bottom: -15px">
        <a-descriptions-item :label="$t('business.label.receiptOrderNo')">
          <a-input-search v-model="receiptOrder.no" :disabled="!editable" class="orderInfo" @pressEnter="searchByNo" @search="searchByNo"/>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">{{$t('business.label.supplier')}}</span>
          <span>{{data.order.customerName}}</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">{{$t('business.label.inspector') + '1'}}</span>
          <span v-if="receiptDetail.inspector">{{receiptDetail.inspector}}</span>
          <span v-else>{{operator.name}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.orderType')">
          <span>{{receiptOrder.orderType.name}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.orderStatus')">
          <span>{{data.order.orderStatus === null || orderStatusData.length === 0 ? null : orderStatusData.find(item => item.ordinal === data.order.orderStatus).name}}</span>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">{{$t('business.label.inspector') + '2'}}</span>
          <a-input-search v-model="data.detail.inspector2" :disabled="!editable" class="orderInfo" readOnly @dblclick="()=>this.$refs.employeeModal.open()" @pressEnter="()=>this.$refs.employeeModal.open()" @search="()=>this.$refs.employeeModal.open()"/>
          <employee-modal ref="employeeModal" @change="(user)=>{data.detail.inspector2=user.length===0?null:user[0].name}"/>
        </a-descriptions-item>
      </a-descriptions>
    </a-row>
    <a-divider style="margin-top: 2px"/>
    <a-row>
      <a-col :span="8">
        <a-descriptions :column="2" style="margin-top: -24px;margin-bottom: -15px">
          <a-descriptions-item :label="$t('business.label.itemNo')" span="1">
            <a-input-search ref="itemSearch" v-model="receiptDetail.item.no" :disabled="!editable" :loading="itemSearching" class="detailInfo" @pressEnter="searchByItem" @search="searchByItem"/>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="strikingFont">{{$t('business.label.inspectedQuantity')}}</span>
            <span class="strikingFont">{{receiptDetail.inspectedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.itemName')}}</span>
            <span class="normalFont">{{receiptDetail.item.name}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.quantity')}}</span>
            <a-input-number ref="acceptedQuantityEditor" v-model="receiptDetail.acceptedQuantity" :disabled="!editable" :max="data.detail.unacceptedQuantity" :min="0" class="detailInfo" @change="acceptedQuantityQuantityChange"
                            @focus="onAcceptedQuantityFocus"/>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.cases')}}</span>
            <a-input-number v-model="data.detail.boxQuantity" :disabled="!editable" :max="receiptDetail.pack.factor?Math.floor(data.detail.unacceptedQuantity/receiptDetail.pack.factor):0" :min="0" class="detailInfo" @change="boxQuantityChange"/>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">{{$t('business.label.numberOfEach')}}</span>
            <span>{{data.detail.eachQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">{{$t('business.label.rejectedQuantityOfAcceptance')}}</span>
            <a-input-number v-model="receiptDetail.rejectedQuantityOfAcceptance" :disabled="!editable" :max="data.detail.unacceptedQuantity" :min="0" class="detailInfo"/>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.lot')}}</span>
            <span class="normalFont">{{receiptDetail.lot.no}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.productionDate')}}</span>
            <span class="normalFont">{{isLegal(receiptDetail.lot.productionDate) ? moment(receiptDetail.lot.productionDate).format('YYYY-MM-DD') : null}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.validUntil')}}</span>
            <span class="normalFont">{{isLegal(receiptDetail.lot.validUntil) ? moment(receiptDetail.lot.productionDate).format('YYYY-MM-DD') : null}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.approvalNo')}}</span>
            <span class="normalFont">{{receiptDetail.lot.approvalNo}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.producingArea')}}</span>
            <span class="normalFont">{{receiptDetail.lot.producingArea}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.manufacturer')}}</span>
            <span class="normalFont">{{receiptDetail.lot.manufacturer}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label">{{$t('business.label.inboundStorageRoom')}}</span>
            <a-select v-model="receiptDetail.storageRoom.id" :disabled="!editable" allowClear class="orderInfo">
              <a-select-option v-for="data in storageRoomData" :key="data.id">{{data.name}}{{data.limit === null || data.limit === undefined ? null : '(' + data.limit + ')'}}
              </a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label">{{$t('business.label.containerNo')}}</span>
            <a-input-search v-model="receiptDetail.container.no" :disabled="!editable" class="orderInfo" readOnly @dblclick="()=>this.$refs.containerModal.open()" @pressEnter="()=>this.$refs.containerModal.open()"
                            @search="()=>this.$refs.containerModal.open()"/>
            <container-modal ref="containerModal" @change="(ctn)=>{receiptDetail.container=ctn.length===0?new Container(): Object.assign(new Container,ctn[0])}"/>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label">{{$t('business.label.receiptConclusion')}}</span>
            <a-select class="orderInfo" v-model="receiptDetail.receiptConclusion.id" :disabled="!editable" allowClear>
              <a-select-option v-for="data in receiptConclusionData" :key="data.id">{{data.name}}</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label">{{$t('business.label.rejectedReason')}}</span>
            <a-select class="orderInfo" v-model="receiptDetail.rejectedReasonOfAcceptance.id" :disabled="receiptDetail.rejectedQuantityOfAcceptance===0||!editable" allowClear>
              <a-select-option v-for="data in rejectedReasonOfAcceptanceData" :key="data.id">{{data.name}}</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label">{{$t('business.label.treatmentSuggestion')}}</span>
            <a-select v-model="receiptDetail.opinionOfAcceptance.id" :disabled="receiptDetail.rejectedQuantityOfAcceptance===0 || !editable" allowClear class="orderInfo">
              <a-select-option v-for="data in opinionData" :key="data.id">{{data.name}}</a-select-option>
            </a-select>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="9">
        <a-descriptions :column="3" style="margin-top: -24px;margin-bottom: -15px">
          <a-descriptions-item :label="$t('business.label.receiptTotalQuantity')" :span="storageRoomData.length>1?1:3">
            <span>{{data.detail.totalQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2" v-if="storageRoomData.length>1">
            <span slot="label">{{$t('business.label.locationLimit')}}</span>
            <a-tooltip :title="getStrings(storageRoomData, 'name')">{{truncateString(getStrings(storageRoomData, 'name'), 18)}}</a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">{{$t('business.label.unreceivedQuantity')}}</span>
            <span class="normalFont">{{data.detail.unreceivedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.receivedQuantity')}}</span>
            <span class="normalFont">{{data.detail.receivedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.rejectedQuantity')">
            <span>{{data.detail.rejectedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.unacceptedQuantity')}}</span>
            <span class="normalFont">{{data.detail.unacceptedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.acceptedQuantity')">
            <span>{{data.detail.acceptedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.rejectedQuantityOfAcceptance')">
            <span>{{data.detail.rejectedQuantityOfAcceptance}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="3">
            <span slot="label" class="normalFont">{{$t('business.label.specification')}}</span>
            <span class="normalFont">{{receiptDetail.pack.specification}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">{{$t('business.label.packagingUnit')}}</span>
            <span>{{receiptDetail.pack.uom}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">{{$t('business.label.factor')}}</span>
            <span>{{receiptDetail.pack.factor}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.innerFactor')">
            <span>{{receiptDetail.pack.innerFactor}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.itemBarcode')" span="3">
            <span>{{receiptDetail.item.barcodes}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.qualityStandard')" span="3">
            <span>{{receiptDetail.item.quality}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="3">
            <span slot="label">{{$t('business.label.legalAttribute')}}</span>
            <span>{{data.detail.legalAttribute.name}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="3">
            <span slot="label">{{$t('business.label.dosageForm')}}</span>
            <span>{{data.detail.dosageForm.name}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="3">
            <span slot="label">{{$t('business.label.permitHolder')}}</span>
            <span>{{receiptDetail.item.permitHolder}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="1">
            <span slot="label" class="strikingFont">{{$t('business.label.visualized')}}</span>
            <a-checkbox :checked="receiptDetail.item.visualized"/>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="strikingFont">{{$t('business.label.scattered')}}</span>
            <a-checkbox :checked="receiptDetail.item.scattered"/>
          </a-descriptions-item>
        </a-descriptions>
        <a-textarea v-if="editable" v-model="receiptDetail.notes" :auto-size="{ minRows: 5, maxRows: 7 }" :placeholder="$t('business.label.notes')" style="width: 80%"/>
      </a-col>
      <a-col :span="7">
        <a-card style="width: 100%;">
          <img slot="cover" alt="example" src="@/assets/example.jpeg"/>
          <img slot="cover" alt="example" src="@/assets/example.jpeg"/>
        </a-card>
        <a-descriptions :column="2" style="margin-top: 10px;margin-left: 25%">
          <a-descriptions-item>
            <span v-if="receiptDetail.item.valuable" class="strikingFont">{{$t('business.label.valuable')}}</span>
            <span v-else class="ignoreFont">{{$t('business.label.valuable')}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="receiptDetail.item.special" class="strikingFont">{{$t('business.label.special')}}</span>
            <span v-else class="ignoreFont">{{$t('business.label.special')}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="receiptDetail.item.supervised" class="strikingFont">{{$t('business.label.supervised')}}</span>
            <span v-else class="ignoreFont">{{$t('business.label.supervised')}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="receiptDetail.item.fragile" class="strikingFont">{{$t('business.label.fragile')}}</span>
            <span v-else class="ignoreFont">{{$t('business.label.fragile')}}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
    <InspectDetailModal ref="inspectDetailModal" @change="pickUpByReceiptDetail"/>
  </a-spin>
</template>

<script>
import { findAll, findOne, post } from '@/api/Api'
import Vue from 'vue'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import ACol from 'ant-design-vue/es/grid/Col'
import ARow from 'ant-design-vue/es/grid/Row'
import ContainerModal from '@/views/modal/ContainerModal.vue'
import Api from '@/api'
import api from '@/api'
import { ReceiptDetail, ReceiptOrder } from '@/api/dto/order/ReceiptOrder'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { Container } from '@/api/dto/common/Container'
import InspectDetailModal from '@/views/inbound/inspect/modal/InspectDetailModal.vue'
import EmployeeModal from '@/views/modal/UserModal.vue'
import { getStrings, isLegal, truncateString } from '@/utils/util'
import { DeviceHandler } from '@/deviceHelper'
import moment from 'moment/moment'

export default {
  name: 'InspectEdit',
  computed: {
    moment() {
      return moment
    },
    Container() {
      return Container
    }
  },
  components: {
    EmployeeModal,
    InspectDetailModal,
    ContainerModal,
    ARow,
    ACol
  },
  data() {
    return {
      data: {
        order: {
          customerName: null,
          orderStatus: null
        },
        detail: {
          inspector2: null,
          boxQuantity: 0,
          eachQuantity: 0,
          totalQuantity: 0,
          receivedQuantity: 0,
          unreceivedQuantity: 0,
          rejectedQuantity: 0,
          acceptedQuantity: 0,
          unacceptedQuantity: 0,
          rejectedQuantityOfAcceptance: 0,
          legalAttribute: new Dictionary(),
          dosageForm: new Dictionary()
        },
        receiptingOrder: null
      },
      receiptOrder: new ReceiptOrder(),
      receiptDetail: new ReceiptDetail(),
      storageRoomData: [],
      receiptConclusionData: [],
      rejectedReasonOfAcceptanceData: [],
      opinionData: [],
      warehouse: Vue.ls.get(WAREHOUSE),
      operator: Vue.ls.get(OPERATOR),
      loading: false,
      itemSearching: false,
      editable: true
    }
  },
  props: {
    orderStatusData: {
      type: Array,
      default: []
    }
  },
  async created() {
    await findOne('fieldFactory', { no: 'RECEIPT_CONCLUSION' }).then(res => {
      if (res.success) {
        this.receiptConclusionData = res.result.dictionaries
      }
    })
    await findOne('fieldFactory', { no: 'REJECT_REASON' }).then(res => {
      if (res.success) {
        this.rejectedReasonOfAcceptanceData = res.result.dictionaries
      }
    })
    await findOne('fieldFactory', { no: 'OPINION' }).then(res => {
      if (res.success) {
        this.opinionData = res.result.dictionaries
      }
    })
  },
  methods: {
    truncateString,
    isLegal,
    getStrings,
    searchByNo() {
      if (this.receiptOrder.no) {
        const args = {
          'order.no': this.receiptOrder.no.trim(),
          asnOrderStatusRange: { start: 'SUBMITTED', end: 'INSPECTING' },
          refundable: false
        }
        this.getOrder(args)
      } else {
        return this.$warning({
          title: '请先输入收货单号',
          centered: true,
          okText: '确定'
        })
      }
    },
    getOrder(args) {
      this.loading = true
      findAll('receivingReceiptListFactory', args).then(res => {
        if (res.success) {
          if (res.result.length > 0) {
            let order = res.result[0].order
            order.orderType = res.result[0].orderType
            order.storer = res.result[0].storer
            order.asnOrder = res.result[0].asnOrder
            order.asnOrder.customer = res.result[0].customer
            this.fetchOrder(order)
          } else {
            this.$warning({
              title: '未查询到相关单据或该单据已验收结束',
              centered: true,
              okText: '确定'
            })
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    fetchOrder(order) {
      this.receiptOrder = new ReceiptOrder(order)
      this.data.order.customerName = order.asnOrder.customer.name
      this.data.order.orderStatus = order.orderStatus
      this.data.receiptingOrder = order
      if (this.receiptDetail.item.no) {
        this.clearDetail()
      }
      this.$nextTick(() => {
        this.$refs.itemSearch.focus()
      })
    },
    searchByItem() {
      if (this.receiptDetail.item.no === null || this.receiptDetail.item.no === undefined || this.receiptDetail.item.no.trim() === '') {
        if (this.receiptOrder.no === null || this.receiptOrder.no === undefined || this.receiptOrder.no.trim() === '') {
          return this.$warning({
            title: '请先输入收货单号',
            centered: true,
            okText: '确定'
          })
        } else {
          this.itemSearching = true
          findAll('receiptDetailFactory', { no: this.receiptOrder.no.trim(), inspected: false, aggregate: true }).then(res => {
            if (res.success) {
              this.$refs.inspectDetailModal.open(res.result)
            }
          }).finally(() => {
            this.itemSearching = false
          })
        }
      } else {
        this.itemSearching = true
        findAll('receiptDetailFactory', { no: this.receiptOrder.no.trim(), 'item.no': this.receiptDetail.item.no.trim(), inspected: false, aggregate: true }).then(res => {
          if (res.success) {
            const dtls = res.result
            if (dtls.length > 0) {
              if (dtls.length === 1) {
                this.pickUpByReceiptDetail(dtls[0])
              } else {
                this.$refs.inspectDetailModal.open(dtls)
              }
            } else {
              this.receiptDetail.item.no = ''
              return this.$warning({
                title: '未查询到相关商品明细',
                centered: true,
                okText: '确定'
              })
            }
          }
        }).finally(() => {
          this.itemSearching = false
        })
      }
    },
    pickUpByReceiptDetail(receiptDetail) {
      if (receiptDetail.detail.acceptedQuantity + receiptDetail.detail.rejectedQuantityOfAcceptance === receiptDetail.detail.receivedQuantity) {
        this.editable = false
        this.$emit('saveDisabled', true)
      } else {
        this.editable = true
        this.$emit('saveDisabled', false)
      }
      const order = {
        id: receiptDetail.order.id,
        no: receiptDetail.order.no,
        dataSource: receiptDetail.order.dataSource,
        orderType: receiptDetail.orderType,
        storer: receiptDetail.storer,
        customer: receiptDetail.customer,
        orderStatus: receiptDetail.asnOrder.orderStatus
      }
      this.receiptOrder = new ReceiptOrder(order)
      const detail = {
        id: receiptDetail.detail.id,
        item: receiptDetail.item,
        pack: receiptDetail.pack,
        lot: receiptDetail.lot,
        serialNumber: receiptDetail.serialNumber,
        container: receiptDetail.container,
        storageRoom: receiptDetail.storageRoom,
        invoiceQuantity: receiptDetail.detail.invoiceQuantity,
        receivedQuantity: receiptDetail.detail.receivedQuantity,
        receiptConclusion: receiptDetail.receiptConclusion,
        rejectedQuantity: receiptDetail.detail.rejectedQuantity,
        inspectedQuantity: receiptDetail.detail.inspectedQuantity,
        acceptedQuantity: this.editable ? 0 : receiptDetail.detail.acceptedQuantity,
        rejectedQuantityOfAcceptance: this.editable ? 0 : receiptDetail.rejectedQuantityOfAcceptance,
        opinionOfAcceptance: this.editable ? null : receiptDetail.opinionOfAcceptance,
        rejectedReasonOfAcceptance: this.editable ? null : receiptDetail.rejectedReasonOfAcceptance
      }
      detail.item.legalAttribute = receiptDetail.legalAttribute
      detail.item.dosageForm = receiptDetail.dosageForm
      detail.lot.quality = receiptDetail.quality
      detail.lot.license = receiptDetail.license
      detail.lot.permission = receiptDetail.permission
      detail.lot.practice = receiptDetail.practice
      if (detail.inspector !== null && detail.inspector !== undefined && detail.inspector.includes(',')) {
        const inspectArr = detail.inspector.split(',')
        detail.inspector = inspectArr[0]
        this.data.detail.inspector2 = inspectArr[1]
      }
      this.data.order.customerName = order.customer.name
      this.data.order.orderStatus = order.orderStatus
      this.data.detail.boxQuantity = Math.floor(detail.acceptedQuantity / detail.pack.factor)
      this.data.detail.eachQuantity = detail.acceptedQuantity % detail.pack.factor
      this.data.detail.totalQuantity = detail.invoiceQuantity
      this.data.detail.receivedQuantity = detail.receivedQuantity
      this.data.detail.rejectedQuantity = detail.rejectedQuantity
      this.data.detail.unreceivedQuantity = receiptDetail.detail.invoiceQuantity - receiptDetail.detail.receivedQuantity - receiptDetail.detail.rejectedQuantity
      this.data.detail.acceptedQuantity = receiptDetail.detail.acceptedQuantity
      this.data.detail.rejectedQuantityOfAcceptance = receiptDetail.detail.rejectedQuantityOfAcceptance
      this.data.detail.unacceptedQuantity = receiptDetail.detail.receivedQuantity - receiptDetail.detail.acceptedQuantity - receiptDetail.detail.rejectedQuantityOfAcceptance
      this.data.detail.dosageForm = receiptDetail.dosageForm === null || receiptDetail.dosageForm === undefined ? new Dictionary() : receiptDetail.dosageForm
      this.data.detail.legalAttribute = receiptDetail.legalAttribute === null || receiptDetail.legalAttribute === undefined ? new Dictionary() : receiptDetail.legalAttribute
      if (this.editable) {
        this.acquireStorageRoom(detail.item.id).then(() => {
          this.receiptDetail = new ReceiptDetail(detail)
          this.$nextTick(() => {
            this.$refs.acceptedQuantityEditor.focus()
          })
        })
      } else {
        this.storageRoomData = [detail.storageRoom]
        this.receiptDetail = new ReceiptDetail(detail)
      }
    },
    acquireStorageRoom(itemId) {
      return new Promise((resolve) => {
        if (itemId === '' || itemId === null || itemId === undefined) {
          this.$warning({ title: '未获取到商品信息,加载失败', centered: true })
          return resolve()
        }
        const args = {
          'query.no': 'limitStorageRoom',
          'sql': null,
          args: { whId: this.warehouse.id, itemId: itemId }
        }
        post(Api.adminQuery, {}, args).then(res => {
          if (res.success) {
            this.storageRoomData = res.result
          }
        }).finally(() => {
          this.loading = false
          resolve()
        })
      })
    },
    onAcceptedQuantityFocus(e) {
      e.target.select()
    },
    acceptedQuantityQuantityChange() {
      if (this.receiptDetail.pack.factor) {
        this.data.detail.boxQuantity = Math.floor(this.receiptDetail.acceptedQuantity / this.receiptDetail.pack.factor)
        this.data.detail.eachQuantity = this.receiptDetail.acceptedQuantity % this.receiptDetail.pack.factor
      }
    },
    boxQuantityChange() {
      if (this.receiptDetail.pack.factor) {
        this.receiptDetail.acceptedQuantity = this.data.detail.boxQuantity * this.receiptDetail.pack.factor
        this.data.detail.eachQuantity = 0
      }
    },
    clearOrder() {
      this.receiptOrder = new ReceiptOrder()
      this.data.order = {
        customerName: null,
        orderStatus: null
      }
    },
    clearDetail() {
      this.receiptDetail = new ReceiptDetail()
      this.data.detail = {
        inspector2: null,
        receivedCase: 0,
        eachQuantity: 0,
        totalQuantity: 0,
        receivedQuantity: 0,
        unReceiptQuantity: 0,
        rejectedQuantity: 0,
        acceptedQuantity: 0,
        unAcceptedQuantity: 0,
        rejectedQuantityOfAcceptance: 0,
        legalAttribute: new Dictionary(),
        dosageForm: new Dictionary()
      }
      this.storageRoomData = []
    },
    clear() {
      this.clearOrder()
      this.clearDetail()
      this.data.receiptingOrder = null
      this.editable = true
    },
    saveReceipt() {
      if (this.receiptOrder.storer.isNew()) {
        return this.$warning({
          title: '缺少单据信息',
          centered: true,
          okText: '确定'
        })
      }
      if (this.receiptDetail.item.isNew()) {
        return this.$warning({
          title: '缺少商品信息',
          centered: true,
          okText: '确定'
        })
      }
      if (this.receiptDetail.acceptedQuantity === 0 && this.receiptDetail.rejectedQuantityOfAcceptance === 0) {
        return this.$warning({
          title: '验收数量与拒验数量不能同时为0',
          centered: true,
          okText: '确定'
        })
      }
      if (this.receiptDetail.receiptConclusion.isNew()) {
        return this.$warning({
          title: '请选择验收结论',
          centered: true,
          okText: '确定'
        })
      }
      this.$emit('saveStart')
      this.loading = true
      const saveData = {
        allocate: true,
        tag: false,
        order: {
          id: this.receiptOrder.id,
          dataSource: this.receiptOrder.dataSource,
          no: this.receiptOrder.no,
          notes: this.receiptDetail.notes,
          orderType: this.receiptOrder.orderType,
          storer: this.receiptOrder.storer,
          warehouse: this.warehouse,
          details: [{
            item: this.receiptDetail.item,
            pack: this.receiptDetail.pack,
            lot: this.receiptDetail.lot,
            inspector: this.data.detail.inspector2 === null || this.data.detail.inspector2 === undefined ? this.operator.name : this.operator.name + ',' + this.data.detail.inspector2,
            container: this.receiptDetail.container.skipNulls(),
            storageRoom: this.receiptDetail.storageRoom.skipNulls(),
            invoiceQuantity: this.receiptDetail.receivedQuantity,
            receivedQuantity: this.receiptDetail.receivedQuantity,
            receiptConclusion: this.receiptDetail.receiptConclusion.skipNulls(),
            acceptedQuantity: this.receiptDetail.acceptedQuantity,
            rejectedQuantityOfAcceptance: this.receiptDetail.rejectedQuantityOfAcceptance,
            rejectedReasonOfAcceptance: this.receiptDetail.rejectedReasonOfAcceptance.skipNulls(),
            opinionOfAcceptance: this.receiptDetail.opinionOfAcceptance.skipNulls(),
            notes: this.receiptDetail.notes
          }]
        }
      }
      post(Api.receivingReceiverAccept, { type: 'normalInboundReceiver' }, saveData).then(res => {
        if (res.success) {
          const that = this
          this.printData(res.result)
          this.$success({
            title: '保存成功',
            okText: '确定',
            onOk() {
              that.searchByNo()
            },
            onCancel() {
              that.searchByNo()
            },
            centered: true
          })
        }
      }).finally(() => {
        this.$emit('saveFinish')
        this.loading = false
      })
    },
    printData(data) {
      if (data.commandGroup === null || data.commandGroup === undefined) {
        return
      }
      const body1 = {
        'query.no': 'receivingCheckPrint',
        sql: null,
        args: {
          commandGroup: data.commandGroup
        }
      }
      post(Api.adminQuery, {}, body1).then(res => {
        if (res.result.length > 0) {
          const Dt = []
          res.result.map(data => {
            data.zhxs = '入(' + parseInt(data.zhjs).toFixed(1) + '箱)'
            data.spmcgg = data.spmc + ' / ' + data.gg
            data.phxq = data.ph + ' / ' + data.xq
            data.sldw = '数量：' + data.sl + '(' + data.dw + ')'
            data.qyxx = data.qy + ' / ' + data.lc + data.zs + ' / ' + data.spbh
            data.dhrq = data.asnNo + ' / ' + data.scrq
            data.bdm = data.pzwh + '箱数量：' + data.bzs + ' / ' + data.fdsx
            Dt.push(data)
          })
          if (Dt.length > 0) {
            const printList = []
            printList.push(
              {
                'PLAN_CODE': '080027',
                'WH_ID': 1000000001,
                'DATA': Dt
              }
            )
            DeviceHandler.printWithDataList(printList, (q, res) => {
              post(api.receivingReceiverPrintUpdate, {}, { commandGroup: data.commandGroup })
            })
          }
        } else {
          this.$message.warning('无可打印数据')
        }
      })
    }
  }

}
</script>
<style scoped>
.orderInfo {
  width: 300px;
}

.detailInfo {
  width: 150px;
}

.normalFont {
  font-weight: bold;
  color: #404040;
}

.strikingFont {
  font-weight: bold;
  font-size: 22px;
  color: red;
}

.ignoreFont {
  font-weight: bold;
  font-size: 22px;
  color: #837D7DFF;
}
</style>